/**
 * This file was auto-generated by Fern from our API Definition.
 */
export const AppType = {
    Portal: "PORTAL",
    Projects: "PROJECTS",
    Mapping: "MAPPING",
    Workbooks: "WORKBOOKS",
    Custom: "CUSTOM",
};
